import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'
const getTranslateMasterFilters = function () {
  return {
    cif: { label: i18n.t('companies.cif').toLowerCase(), value: '' },
    name: { label: i18n.t('companies.companyName'), value: '' },
    direccion: { label: i18n.t('address.location'), value: '' },
    registro_mercantil: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
    codigo_postal: { label: i18n.t('address.codigo_postal'), value: '' },
    telefono: { label: i18n.t('address.telefono'), value: '' },
    pais: { label: i18n.t('address.pais'), value: '' },
    distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
    idCliente: { label: i18n.t('clients.id_client'), value: '' },
    cliente: { label: i18n.t('clients.entity_name'), value: '' }, 
  }
}
const getTranslateColumns = () => [
  { field: 'Sociedad.NameCorporateName', title: i18n.t('companies.companyName'), columnMenu: 'myTemplate', width: '200px', locked: false },
  { field: 'Sociedad.TIN', title: i18n.t('companies.cif'), columnMenu: 'myTemplate', width: '150px', locked: false },
  { field: 'LocationName', title: i18n.t('sedes.entity_name'), columnMenu: 'myTemplate', width: '150px', locked: false },
  { field: 'SendType', title: i18n.t('app.forma_envio'), format: '["TIPOS_PGE" , "TIPOS_PGE_RECEPCION"]', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '200px', locked: false },
  { field: 'Address.Address', title: i18n.t('address.location'), columnMenu: 'myTemplate', width: '200px', locked: false },
  { field: 'Address.PostCode', title: i18n.t('address.codigo_postal'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
  { field: 'Address.CountryCode', title: i18n.t('address.pais'), format: 'PAISES', cell: 'enumTemplate', hidden: true, columnMenu: 'myTemplate', width: '200px', locked: false },
  { field: 'ContactDetails.ElectronicMail', title: i18n.tc('users.email', 1), hidden: true, columnMenu: 'myTemplate', width: '200px', locked: false },
  { field: 'ContactDetails.Telephone', title: i18n.t('address.telefono'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
]
const getDefaultForm = () => ({ receiver: '' })
const customState = { form: getDefaultForm() }
const customGetters = {
  form: state => state.form
}
const customActions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}
const mystore = parent({ getTranslateColumns, customState, customGetters, customActions, selectable: true, navigate: false, namespaced: true, getTranslateMasterFilters })

export default mystore
